module.exports = __webpack_public_path__ + "media/directory/weekend_icon_hover-7674ab63.svg";